import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/AdminLayout.css";

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
    navigate("/admin/login");
  };

  const menuItems = [
    { path: "/admin/dashboard", icon: "ri-dashboard-line", label: "Dashboard" },
    { path: "/admin/tours", icon: "ri-map-pin-line", label: "Tours" },
    { path: "/admin/tours/add", icon: "ri-add-circle-line", label: "Add Tour" },
    { path: "/admin/bookings", icon: "ri-bookmark-line", label: "Bookings" },
    { path: "/admin/contacts", icon: "ri-mail-line", label: "Contacts" },
    { path: "/admin/blogs", icon: "ri-article-line", label: "Blogs" },
    { path: "/admin/blogs/add", icon: "ri-add-circle-line", label: "Add Blog" },
    { path: "/admin/newsletter", icon: "ri-mail-send-line", label: "Newsletter" },
    { path: "/admin/users", icon: "ri-user-line", label: "Users" },
  ];

  const isActive = (path) => {
    if (path === "/admin/tours/add") {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  return (
    <div className="admin-layout">
      <div className={`admin-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="admin-sidebar-header">
          <h3>Rhythm Admin</h3>
          <button
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            <i className={sidebarOpen ? "ri-menu-fold-line" : "ri-menu-unfold-line"}></i>
          </button>
        </div>
        <nav className="admin-nav">
          {menuItems.map((item) => (
            <div
              key={item.path}
              className={`admin-nav-item ${isActive(item.path) ? "active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              <i className={item.icon}></i>
              {sidebarOpen && <span>{item.label}</span>}
            </div>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <i className="ri-user-line"></i>
            {sidebarOpen && (
              <div>
                <p className="admin-username">{user?.username || "Admin"}</p>
                <p className="admin-email">{user?.email || ""}</p>
              </div>
            )}
          </div>
          <button className="admin-logout-btn" onClick={handleLogout}>
            <i className="ri-logout-box-line"></i>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </div>
      <div className="admin-main-content">
        <div className="admin-header">
          <h2>
            {location.pathname === "/admin/dashboard" && "Dashboard"}
            {location.pathname === "/admin/tours" && "Manage Tours"}
            {location.pathname === "/admin/tours/add" && "Add New Tour"}
            {location.pathname.startsWith("/admin/tours/edit/") && "Edit Tour"}
            {location.pathname === "/admin/bookings" && "Manage Bookings"}
            {location.pathname === "/admin/contacts" && "Contact Messages"}
            {location.pathname === "/admin/blogs" && "Manage Blogs"}
            {location.pathname === "/admin/blogs/add" && "Add New Blog"}
            {location.pathname.startsWith("/admin/blogs/edit/") && "Edit Blog"}
            {location.pathname === "/admin/newsletter" && "Newsletter Subscribers"}
            {location.pathname === "/admin/users" && "Manage Users"}
          </h2>
          <div className="admin-header-actions">
            <a href="/" className="view-website-btn" target="_blank" rel="noopener noreferrer">
              <i className="ri-external-link-line"></i> View Website
            </a>
          </div>
        </div>
        <div className="admin-content">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout;

